import Component from "./View";
export default Component;
